<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-center" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" *ngIf='displayState.workingDiv || viewCount < 5'>
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>

<div class="card bg-light" *ngIf='viewCount>4' style="margin-top: 5px;">
    <div class="card-body"style="margin-bottom: 3px;">
        <div class="row" style="height: 20px;">
            <div class="col-md-12 bold" style="text-align: center;"><h5>View/Print Case List Report</h5></div>
        </div>
        <br />
        <div class="row" style="position: sticky; height: 20px;">
            <div class="col-md-3"><h6 style="font-weight: bold">Selection Variables</h6>  </div>
            <!--<div class="col-md-7 alert-danger">Enter dates in format dd/mm/yyyy, e.g. 09/15/2014</div>-->
        </div>
      <div class="row" style="margin-top: 5px;">
        <div class="col-md-12" style="height: 635px; overflow-y: auto;">
          <table class="table">
            <tr>
              <td class="bold">From Date Recvd</td>
              <td><p-calendar [disabledDays]="[0,6]" [(ngModel)]="myFilter.fromDateRecvd" dateFormat="mm/dd/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2050" ></p-calendar></td>
              <td class="bold">Thru Date Recvd</td>
              <td><p-calendar [disabledDays]="[0,6]" [(ngModel)]="myFilter.thruDateRecvd" dateFormat="mm/dd/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2050" ></p-calendar></td>
            </tr>
            <tr>
              <td class="bold">From Date Closed</td>
              <td><p-calendar [disabledDays]="[0,6]" [(ngModel)]="myFilter.fromDateClosed" dateFormat="mm/dd/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2050" ></p-calendar></td>
              <td class="bold">Thru Date Closed</td>
              <td><p-calendar [disabledDays]="[0,6]" [(ngModel)]="myFilter.thruDateClosed" dateFormat="mm/dd/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2050" ></p-calendar></td>

            </tr>
            <tr>
              <td class="bold">Current Status</td>
              <td>
                <select [(ngModel)] = "myFilter.currentStatus">
                  <option></option>
                  <option *ngFor="let stat of statusList">{{stat}}</option>
                </select>
              </td>
              <td class="bold">Sub-Status</td>
              <td>
                <select [(ngModel)] = "myFilter.subStatus">
                  <option></option>
                  <option *ngFor="let subStat of subStatusList">{{subStat}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bold">Applicant</td>
              <td><input title="Search for applicant whose name starts with entered value" type="text" [(ngModel)] = "myFilter.applicant" /></td>
              <td class="bold">Agency</td>
              <td><input title="Search for Agency whose name starts with entered value" type="text" [(ngModel)] = "myFilter.agency" /></td>
            </tr>
            <tr>
              <td class="bold">Property Type</td>
              <td>
                <select [(ngModel)] = "myFilter.propType">
                  <option></option>
                  <option *ngFor="let propType of propTypeList">{{propType}}</option>
                </select>
              </td>
              <td class="bold">Property Street</td>
              <td><input title="Search for property street whose name starts with entered value" type="text" [(ngModel)] = "myFilter.propStreet" /></td>
              <td class="bold">Property City</td>
              <td>
                <select [(ngModel)] = "myFilter.propCity">
                  <option></option>
                  <option *ngFor="let city of cityList">{{city}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bold">Use Code</td>
              <td>
                <select [(ngModel)] = "myFilter.useCode">
                  <option *ngFor="let useCode of useCodeList">{{useCode.description}}</option>
                </select>
              </td>
              <td class="bold">TRA</td>
              <td><input type="text" [(ngModel)] = "myFilter.tra" /></td>
              <td class="bold">Assessment Type</td>
              <td>
                <select [(ngModel)] = "myFilter.assessType">
                  <option></option>
                  <option *ngFor="let assessment of assessTypeList">{{assessment}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bold">Secured?</td>
              <td>
                <select [(ngModel)] = "myFilter.secured">
                  <option></option>
                  <option *ngFor="let secure of secureList">{{secure}}</option>
                </select>
              </td>
              <td class="bold">Closed/Open</td>
              <td>
                <select [(ngModel)] = "myFilter.closedOpen">
                  <option></option>
                  <option>Closed</option>
                  <option>Open</option>
                </select>
              </td>
              <td class="bold">Hearing Date</td>
              <td>
                <select [(ngModel)] = "myFilter.hearingId">
                  <option></option>
                  <!-- <option *ngFor="let hearing of hearingsList" value="{{hearing.id}}">{{hearing.hearingDate | date:'MM/dd/yyyy'}}</option> -->
                  <option *ngFor="let hearing of hearingsList" value="{{hearing.id}}">{{hearing.hearingDateDesc}}</option>
                </select>
              </td>
            </tr>
            <tr>
            </tr>
            <tr>
              <td class="bold">Division</td>
              <td>
                <select [(ngModel)] = "myFilter.division">
                  <option></option>
                  <option *ngFor="let div of divisionList">{{div.division}}</option>
                </select>
              </td>
              <td class="bold">Crew</td>
              <td>
                <select [(ngModel)] = "myFilter.crew">
                  <option></option>
                  <option *ngFor="let crew of crewList">{{crew.crew}}</option>
                </select>
              </td>
              <td class="bold">Appraiser</td>
              <td>
                <select [(ngModel)] = "myFilter.appraiserId">
                  <option></option>
                  <option *ngFor="let appraiser of appraiserList" value="{{appraiser.id}}">{{appraiser.name}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bold">Complex Case</td>
              <td>
                <select [(ngModel)] = "myFilter.complexCase">
                  <option></option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </td>
              <td class="bold">Special Case</td>
              <td>
                <select [(ngModel)] = "myFilter.specialCase">
                  <option></option>
                  <option *ngFor="let specCase of specialCaseList">{{specCase.specialCase}}</option>
                </select>
              </td>
              <td class="bold">Notice Returned</td>
              <td>
                <select [(ngModel)] = "myFilter.noticeReturned">
                  <option></option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="bold">Waiver</td>
              <td>
                <select [(ngModel)] = "myFilter.waiver">
                  <option></option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </td>
              <td class="bold">Claim Refund</td>
              <td>
                <select [(ngModel)] = "myFilter.refund">
                  <option></option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </td>
            </tr>
          </table>
          <hr />
          <div class="row" style="margin-top: 30px;">
            <div class="col-md-2 offset-2">
              <label><b>Sort List By</b></label>&nbsp;
              <select [(ngModel)]="myFilter.sortBy">
                <option></option>
                <option *ngFor="let sortProp of sortByList">{{sortProp}}</option>
              </select>
            </div>
            <div class="col-md-2">
              <label><b>Export to Excel</b></label>
              <input style="margin: 10px;" type="checkbox" [(ngModel)]="myFilter.exportExcel" title="Generate an Excel spreadsheet instead of a PDF file.">
            </div>
            <div class="col-md-1"><button class="btn btn-warning" title="Clicking this button will clear all values entered in the above form" (click)="resetFilters()" style="margin-right: 10px;">Clear Filters</button></div>
            <div class="col-md-2"><button class="btn btn-success" (click)="runCaseListReport()" [disabled]="needVariables()">Run Case List Report</button></div>
          </div>
        </div>
      </div>
    </div>
</div>
